import { Book } from "@/types";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { ScrollLink } from "@/components/ui/scroll-link";
import { trackEvent } from "@/lib/analytics";

interface FeaturedBooksProps {
  books: Book[];
}

export function FeaturedBooks({ books }: FeaturedBooksProps) {
  console.log('Featured Books with IDs:', books.map(b => ({ id: b.id, title: b.title })));
  
  const handleBuyClick = (bookTitle: string) => {
    trackEvent('book_buy_click', { title: bookTitle });
  };

  return (
    <div className="grid gap-6 md:grid-cols-3">
      {books.map((book) => (
        <Card key={book.id} className="overflow-hidden group">
          <ScrollLink to={`/books/${book.slug}`} className="block">
            <div className="aspect-[4/6] relative overflow-hidden bg-muted">
              <img
                src={book.coverUrl}
                alt={book.title}
                className="object-contain w-full h-full transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <CardHeader>
              <CardTitle className="line-clamp-1 group-hover:text-primary transition-colors">
                {book.title}
              </CardTitle>
              <CardDescription className="line-clamp-2">
                {book.description}
              </CardDescription>
            </CardHeader>
          </ScrollLink>
          <CardContent>
            <Button 
              asChild 
              className="w-full"
              onClick={() => handleBuyClick(book.title)}
            >
              <a 
                href={book.amazonLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center"
              >
                Buy on Amazon
                <ExternalLink className="ml-2 h-4 w-4" />
              </a>
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}